export default __webpack_public_path__ + "static/media/free_trial.8d7b9a3f.svg";